import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Button, Modal, Form, Spinner, Alert, Table, InputGroup, FormControl } from 'react-bootstrap';
import Navbarpro from './sidebar';
import { api } from '../../../config';

function CategoryManagement() {
    const [categories, setCategories] = useState([
        {
            id: 'technical',
            name: 'Technical',
            enabled: true,
            commission: 10,
            subCategories: [
                { name: 'Architects', enabled: true, commission: 10 },
                { name: 'Civil Engineer', enabled: true, commission: 10 },
                { name: 'Site Supervisor', enabled: true, commission: 8 },
                { name: 'Survey Engineer', enabled: true, commission: 10 },
                { name: 'MEP Consultant', enabled: true, commission: 12 },
                { name: 'Structural Engineer', enabled: true, commission: 10 },
                { name: 'Project Manager', enabled: true, commission: 15 },
                { name: 'HVAC Engineer', enabled: true, commission: 12 },
                { name: 'Safety Engineer', enabled: true, commission: 10 },
                { name: 'Contractor', enabled: true, commission: 8 },
                { name: 'Interior Designer', enabled: true, commission: 12 },
                { name: 'Waterproofing Consultant', enabled: true, commission: 10 },
                { name: 'Acoustic Consultants', enabled: true, commission: 12 }
            ]
        },
        {
            id: 'non-technical',
            name: 'Non-Technical',
            enabled: true,
            commission: 8,
            subCategories: [
                { name: 'Earthwork Labour', enabled: true, commission: 8 },
                { name: 'Civil Mason', enabled: true, commission: 8 },
                { name: 'Shuttering/Centring Labour', enabled: true, commission: 8 },
                { name: 'Plumber', enabled: true, commission: 8 },
                { name: 'Electrician', enabled: true, commission: 8 },
                { name: 'Painter', enabled: true, commission: 8 },
                { name: 'Carpenter', enabled: true, commission: 8 },
                { name: 'Flooring Labour', enabled: true, commission: 8 },
                { name: 'False Ceiling Worker', enabled: true, commission: 8 }
            ]
        },
        {
            id: 'products',
            name: 'Products',
            enabled: true,
            commission: 12,
            subCategories: [
                { name: 'Building Materials', enabled: true, commission: 12 },
                { name: 'Electrical Supplies', enabled: true, commission: 10 },
                { name: 'Plumbing Supplies', enabled: true, commission: 10 },
                { name: 'Hardware', enabled: true, commission: 8 },
                { name: 'Safety Equipment', enabled: true, commission: 10 }
            ]
        }
    ]);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showSubModal, setShowSubModal] = useState(false);
    const [selectedSub, setSelectedSub] = useState(null);
    const [success, setSuccess] = useState('');
    const [newSubCategory, setNewSubCategory] = useState({ name: '', commission: 10 });
    const [showAddModal, setShowAddModal] = useState(false);

    const toggleCategory = (categoryId) => {
        setCategories(prev => prev.map(cat =>
            cat.id === categoryId ? { ...cat, enabled: !cat.enabled } : cat
        ));
        setSuccess('Category status updated');
        setTimeout(() => setSuccess(''), 2000);
    };

    const toggleSubCategory = (categoryId, subName) => {
        setCategories(prev => prev.map(cat =>
            cat.id === categoryId ? {
                ...cat,
                subCategories: cat.subCategories.map(sub =>
                    sub.name === subName ? { ...sub, enabled: !sub.enabled } : sub
                )
            } : cat
        ));
        setSuccess('Sub-category status updated');
        setTimeout(() => setSuccess(''), 2000);
    };

    const updateCommission = (categoryId, commission) => {
        setCategories(prev => prev.map(cat =>
            cat.id === categoryId ? { ...cat, commission: parseInt(commission) } : cat
        ));
    };

    const updateSubCommission = (categoryId, subName, commission) => {
        setCategories(prev => prev.map(cat =>
            cat.id === categoryId ? {
                ...cat,
                subCategories: cat.subCategories.map(sub =>
                    sub.name === subName ? { ...sub, commission: parseInt(commission) } : sub
                )
            } : cat
        ));
    };

    const addSubCategory = () => {
        if (!newSubCategory.name || !selectedCategory) return;
        setCategories(prev => prev.map(cat =>
            cat.id === selectedCategory.id ? {
                ...cat,
                subCategories: [...cat.subCategories, { ...newSubCategory, enabled: true }]
            } : cat
        ));
        setNewSubCategory({ name: '', commission: 10 });
        setShowAddModal(false);
        setSuccess('Sub-category added');
        setTimeout(() => setSuccess(''), 2000);
    };

    // Stats
    const stats = {
        total: categories.length,
        active: categories.filter(c => c.enabled).length,
        totalSubs: categories.reduce((sum, c) => sum + c.subCategories.length, 0),
        activeSubs: categories.reduce((sum, c) => sum + c.subCategories.filter(s => s.enabled).length, 0)
    };

    return (
        <div>
            <Navbarpro />

            <Container fluid className="py-4 px-4">
                {/* Page Header */}
                <div className="page-header d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h4 className="mb-1">
                            <i className="bi bi-grid me-2" style={{ color: 'var(--accent-purple)' }}></i>
                            Category Management
                        </h4>
                        <p className="text-secondary mb-0">Manage categories, sub-categories, and commission rates</p>
                    </div>
                </div>

                {/* Alerts */}
                {success && <Alert variant="success" className="fade-in">{success}</Alert>}

                {/* Stats */}
                <Row className="g-3 mb-4">
                    <Col md={3}>
                        <div className="stat-card">
                            <div className="d-flex align-items-center gap-3">
                                <div className="icon" style={{ background: 'rgba(124, 77, 255, 0.1)', color: 'var(--accent-purple)' }}>
                                    <i className="bi bi-grid"></i>
                                </div>
                                <div>
                                    <div className="value">{stats.total}</div>
                                    <div className="label">Categories</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="stat-card">
                            <div className="d-flex align-items-center gap-3">
                                <div className="icon" style={{ background: 'rgba(0, 200, 83, 0.1)', color: 'var(--accent-green)' }}>
                                    <i className="bi bi-check-circle"></i>
                                </div>
                                <div>
                                    <div className="value">{stats.active}</div>
                                    <div className="label">Active</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="stat-card">
                            <div className="d-flex align-items-center gap-3">
                                <div className="icon" style={{ background: 'rgba(0, 212, 255, 0.1)', color: 'var(--accent-cyan)' }}>
                                    <i className="bi bi-tags"></i>
                                </div>
                                <div>
                                    <div className="value">{stats.totalSubs}</div>
                                    <div className="label">Sub-Categories</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="stat-card">
                            <div className="d-flex align-items-center gap-3">
                                <div className="icon" style={{ background: 'rgba(255, 118, 0, 0.1)', color: 'var(--primary)' }}>
                                    <i className="bi bi-percent"></i>
                                </div>
                                <div>
                                    <div className="value">{stats.activeSubs}</div>
                                    <div className="label">Active Subs</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Categories Grid */}
                <Row className="g-4">
                    {categories.map((category) => (
                        <Col lg={4} key={category.id}>
                            <Card className="h-100">
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center gap-2">
                                        <h6 className="mb-0">{category.name}</h6>
                                        <Badge bg={category.enabled ? 'success' : 'secondary'}>
                                            {category.enabled ? 'Active' : 'Disabled'}
                                        </Badge>
                                    </div>
                                    <Form.Check
                                        type="switch"
                                        checked={category.enabled}
                                        onChange={() => toggleCategory(category.id)}
                                    />
                                </Card.Header>
                                <Card.Body>
                                    {/* Commission */}
                                    <div className="mb-4">
                                        <label className="text-secondary small mb-2 d-block">Platform Commission</label>
                                        <InputGroup size="sm">
                                            <FormControl
                                                type="number"
                                                value={category.commission}
                                                onChange={(e) => updateCommission(category.id, e.target.value)}
                                                min="0"
                                                max="50"
                                            />
                                            <InputGroup.Text>%</InputGroup.Text>
                                        </InputGroup>
                                    </div>

                                    {/* Sub-categories */}
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <label className="text-secondary small">Sub-Categories ({category.subCategories.length})</label>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => { setSelectedCategory(category); setShowModal(true); }}
                                            >
                                                <i className="bi bi-pencil me-1"></i> Manage
                                            </Button>
                                        </div>
                                        <div className="d-flex flex-wrap gap-1">
                                            {category.subCategories.slice(0, 5).map((sub, idx) => (
                                                <Badge
                                                    key={idx}
                                                    bg={sub.enabled ? 'primary' : 'secondary'}
                                                    style={{ opacity: sub.enabled ? 1 : 0.5 }}
                                                >
                                                    {sub.name}
                                                </Badge>
                                            ))}
                                            {category.subCategories.length > 5 && (
                                                <Badge bg="secondary">+{category.subCategories.length - 5} more</Badge>
                                            )}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Sub-categories Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                <Modal.Header closeButton style={{ background: 'var(--bg-secondary)' }}>
                    <Modal.Title>
                        <i className="bi bi-tags me-2"></i>
                        {selectedCategory?.name} - Sub-Categories
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '60vh', overflow: 'auto' }}>
                    {selectedCategory && (
                        <>
                            <div className="d-flex justify-content-end mb-3">
                                <Button variant="outline-primary" size="sm" onClick={() => setShowAddModal(true)}>
                                    <i className="bi bi-plus me-1"></i> Add Sub-Category
                                </Button>
                            </div>
                            <Table hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Commission</th>
                                        <th>Status</th>
                                        <th>Toggle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedCategory.subCategories.map((sub, idx) => (
                                        <tr key={idx}>
                                            <td>{sub.name}</td>
                                            <td>
                                                <InputGroup size="sm" style={{ width: '100px' }}>
                                                    <FormControl
                                                        type="number"
                                                        value={sub.commission}
                                                        onChange={(e) => updateSubCommission(selectedCategory.id, sub.name, e.target.value)}
                                                        min="0"
                                                        max="50"
                                                    />
                                                    <InputGroup.Text>%</InputGroup.Text>
                                                </InputGroup>
                                            </td>
                                            <td>
                                                <Badge bg={sub.enabled ? 'success' : 'secondary'}>
                                                    {sub.enabled ? 'Active' : 'Disabled'}
                                                </Badge>
                                            </td>
                                            <td>
                                                <Form.Check
                                                    type="switch"
                                                    checked={sub.enabled}
                                                    onChange={() => toggleSubCategory(selectedCategory.id, sub.name)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>

            {/* Add Sub-category Modal */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
                <Modal.Header closeButton style={{ background: 'var(--bg-secondary)' }}>
                    <Modal.Title>Add Sub-Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            value={newSubCategory.name}
                            onChange={(e) => setNewSubCategory(prev => ({ ...prev, name: e.target.value }))}
                            placeholder="Enter sub-category name"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Commission (%)</Form.Label>
                        <Form.Control
                            type="number"
                            value={newSubCategory.commission}
                            onChange={(e) => setNewSubCategory(prev => ({ ...prev, commission: parseInt(e.target.value) }))}
                            min="0"
                            max="50"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={addSubCategory}>Add</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CategoryManagement;
